module.exports = __webpack_public_path__ + "img/redCrossBack.63546ec1.svg";